import { Network } from "./types";

/**
 * RPC endpoints are supplied by the host app at boot — they come from the
 * backend's /appConfig, never from this library. There is deliberately no
 * default: an unconfigured read must fail loudly rather than quietly reach for
 * some public node.
 */
const rpcUrls: Partial<Record<Network, string>> = {};

export function configureRpcUrls(urls: Partial<Record<Network, string>>): void {
  Object.assign(rpcUrls, urls);
}

export function getRpcUrl(network: Network): string {
  const url = rpcUrls[network];
  if (!url) {
    throw new Error(
      `No RPC URL configured for "${network}". The host app must call ` +
        `configureRpcUrls() with the value from /appConfig before any chain read.`,
    );
  }
  return url;
}
